import styles from './styles';

export type RouteCardProps = {
  routeNumber: number;
  progress?: number;
  title: string;
  backgroundImage?: string;
};

export function RouteCard({ routeNumber, progress, title, backgroundImage, ...rest }: RouteCardProps) {
  return (
    <div style={styles.cardContainer} {...rest}>
      <img
        src={backgroundImage}
        alt="route cover"
        style={styles.img}
      />
      <div style={styles.overlay} />
      <span style={styles.numberText}>{routeNumber}</span>
      {progress != null && (
        <span style={styles.progressText}>{progress === 100 ? 'Completo' : `${Math.floor(progress)}%`}</span>
      )}
      <h3 style={styles.titleText}>{title}</h3>
    </div>
  );
}
